import React from 'react';
import { TokenItem } from '../../utils/types';
import './KycCertificate.css';

interface KycCertificateProps {
  tokens: TokenItem[];
}

const KycCertificate: React.FC<KycCertificateProps> = ({ tokens }) => {
  if (tokens.length === 0 || tokens[0].meta.badges.KYC !== 'true') {
    return null;
  }

  return (
    <div className="kyc-certificate-text">
      <p>
        This certificate confirms that a representative associated with the
        project has successfully completed identity verification procedures and
        that ownership or control of the project has been reasonably verified
        through our verification process.
      </p>
      <p>
        This verification is provided solely as an identity attestation service
        and does not constitute financial advice, legal approval, regulatory
        approval, investment advice, endorsement, a smart contract audit, a
        security audit, or a guarantee regarding the legitimacy, safety, future
        conduct, performance, or financial outcome of the project.
      </p>
      <p>
        Verification does not eliminate the risk of fraud, misconduct, hacks,
        losses, project failure, or unlawful activity. Users should always
        conduct their own independent research and due diligence before
        interacting with any project.
      </p>
      <p>
        In cases involving suspected fraud, scams, unlawful activity, or legal
        investigations, verification records and related information may be
        preserved and disclosed where required by applicable law or pursuant to
        valid legal requests from competent authorities, courts, law enforcement
        agencies, or legally authorized investigative parties.
      </p>
      <a className="full-width-button" href='mailto:support@coinsult.net'>Report Incident</a>
      </div>
  );
};

export default KycCertificate;
